import { render, staticRenderFns } from "./BlogShare.vue?vue&type=template&id=088b49e1&scoped=true&"
import script from "./BlogShare.vue?vue&type=script&lang=js&"
export * from "./BlogShare.vue?vue&type=script&lang=js&"
import style0 from "./BlogShare.vue?vue&type=style&index=0&id=088b49e1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "088b49e1",
  null
  
)

export default component.exports